import { ReactNode } from 'react'
import { LinkedJobibot } from '../../rapid-ui'

export type EditorShellHeadingProps = {
	rightSide?: ReactNode
}
export function EditorShellHeading({ rightSide }: EditorShellHeadingProps) {
	return (
		<div className="flex items-center justify-between py-3 px-4">
			<LinkedJobibot size={32} />
			{rightSide}
		</div>
	)
}
